export default __webpack_public_path__ + "static/media/gallery-wip-construction-improvements-screw-replacement_00.6a3586a4.jpg";